var _defs, _rect, _rect2, _g, _rect3, _text, _text2, _text3, _text4, _text5, _text6, _line, _text7, _text8, _g2, _g3, _g4, _g5, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShadowAiAtWork(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 630",
    width: 1200,
    height: 630,
    role: "img",
    "aria-label": "Shadow AI at work: a small amount of sanctioned AI use visible above the line and a much larger volume of unapproved AI tools hidden below it",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sbg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#121020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#171523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121020"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "sglow",
    cx: 0.74,
    cy: 0.26,
    r: 0.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b7a4e6",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b7a4e6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sai",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8fd8f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#b7a4e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f7fd0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sgold",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe9a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f6cf6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2b24a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sdark",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#121020",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#121020",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121020",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ssoft",
    x: "-40%",
    y: "-40%",
    width: "180%",
    height: "180%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  })), /*#__PURE__*/React.createElement("style", null, "\n      .h  { font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; font-weight: 800; fill: #f4f0fc; }\n      .s  { font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; font-weight: 600; fill: #b8b2cc; }\n      .eyebrow { font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; font-weight: 700; fill: #cfc3ee; letter-spacing: 4px; }\n      .lab { font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; font-weight: 700; fill: #121020; }\n      .node { font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; font-weight: 700; fill: #e2d9f5; }\n      .chip { font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; font-weight: 700; fill: #aaa4bd; }\n      .warn { font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; font-weight: 700; fill: #f6a35a; letter-spacing: 2px; }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 630,
    fill: "url(#sbg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 630,
    fill: "url(#sglow)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#2a2547",
    strokeWidth: 1,
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 90 H1200 M0 180 H1200 M0 270 H1200 M0 360 H1200 M0 450 H1200 M0 540 H1200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 0 V630 M300 0 V630 M450 0 V630 M600 0 V630 M750 0 V630 M900 0 V630 M1050 0 V630"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 300,
    width: 600,
    height: 330,
    fill: "url(#sdark)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 120,
    className: "eyebrow",
    fontSize: 20
  }, "SHADOW AI")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 78,
    y: 188,
    className: "h",
    fontSize: 60
  }, "Your team already")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 78,
    y: 254,
    className: "h",
    fontSize: 60
  }, "automates.")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 78,
    y: 320,
    className: "h",
    fontSize: 60,
    fill: "#cfc3ee"
  }, "You just can't see it.")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 368,
    className: "s",
    fontSize: 24
  }, "Governance beats blocking.")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 588,
    className: "s",
    fontSize: 20,
    opacity: 0.8
  }, "BOSSDROP.AI")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 620,
    y1: 300,
    x2: 1140,
    y2: 300,
    stroke: "#665a9c",
    strokeWidth: 2,
    strokeDasharray: "8 8",
    opacity: 0.9
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 620,
    y: 288,
    className: "node",
    fontSize: 17,
    opacity: 0.95
  }, "What leadership sees")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 620,
    y: 332,
    className: "warn",
    fontSize: 15
  }, "WHAT ACTUALLY RUNS")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 700,
    y: 176,
    width: 300,
    height: 58,
    rx: 29,
    fill: "url(#sai)",
    filter: "url(#ssoft)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 700,
    y: 176,
    width: 300,
    height: 58,
    rx: 29,
    fill: "url(#sai)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 850,
    y: 212,
    textAnchor: "middle",
    className: "lab",
    fontSize: 21
  }, "BossDrop AI layer"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 640,
    cy: 120,
    r: 30,
    fill: "url(#sgold)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 640,
    cy: 110,
    r: 10,
    fill: "#121020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624 134 a16 13 0 0 1 32 0 z",
    fill: "#121020"
  }), /*#__PURE__*/React.createElement("text", {
    x: 690,
    y: 126,
    className: "node",
    fontSize: 17
  }, "Approved. Logged. Reusable."))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    stroke: "url(#sai)",
    strokeWidth: 3,
    fill: "none",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M670 138 C 720 150, 730 168, 760 176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850 234 V 292"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#171523",
    stroke: "#3a3463",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 628,
    y: 356,
    width: 176,
    height: 40,
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 822,
    y: 356,
    width: 188,
    height: 40,
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 628,
    y: 412,
    width: 200,
    height: 40,
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 846,
    y: 412,
    width: 164,
    height: 40,
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 628,
    y: 468,
    width: 158,
    height: 40,
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 804,
    y: 468,
    width: 206,
    height: 40,
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 672,
    y: 524,
    width: 230,
    height: 40,
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 920,
    y: 524,
    width: 130,
    height: 40,
    rx: 12
  })), /*#__PURE__*/React.createElement("g", {
    className: "chip",
    fontSize: 14
  }, /*#__PURE__*/React.createElement("text", {
    x: 646,
    y: 381
  }, "personal chatbot"), /*#__PURE__*/React.createElement("text", {
    x: 840,
    y: 381
  }, "browser extension"), /*#__PURE__*/React.createElement("text", {
    x: 646,
    y: 437
  }, "unvetted meeting bot"), /*#__PURE__*/React.createElement("text", {
    x: 864,
    y: 437
  }, "side-account agent"), /*#__PURE__*/React.createElement("text", {
    x: 646,
    y: 493
  }, "home API key"), /*#__PURE__*/React.createElement("text", {
    x: 822,
    y: 493
  }, "copy-paste of customer data"), /*#__PURE__*/React.createElement("text", {
    x: 690,
    y: 549
  }, "script nobody else can run"), /*#__PURE__*/React.createElement("text", {
    x: 938,
    y: 549
  }, "no audit log")))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    stroke: "#f6a35a",
    strokeWidth: 2,
    strokeDasharray: "5 7",
    opacity: 0.55,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1010 376 H1160"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010 432 H1160"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010 488 H1160"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadowAiAtWork);
export default __webpack_public_path__ + "static/media/shadow-ai-at-work.787ecd44c0c9ac4795fdda6259b34238.svg";
export { ForwardRef as ReactComponent };